export default __webpack_public_path__ + "media/images/dashboard_icons/profile_pic-6ec75c301c9786598318096dd27433a4.svg";